var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 283,
    viewBox: "0 0 442 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.738281,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "#7BAC5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.184 139.693C318.336 139.55 340.827 131.651 358.082 143.895C377.386 157.593 392.897 181.481 388.986 204.836C385.264 227.069 356.417 232.232 340.603 248.287C324.546 264.589 320.03 296.906 297.184 298.042C274.38 299.177 265.433 268.921 249.222 252.833C232.878 236.613 205.832 227.727 203.266 204.836C200.603 181.074 217.463 158.333 237.101 144.711C254.272 132.801 276.292 139.834 297.184 139.693Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.069 -45.6555C333.259 -52.375 361.559 -41.8633 391.72 -34.9152C430.792 -25.9143 479.183 -32.863 502 0.172191C526.344 35.4187 524.265 87.6602 501.308 123.751C480.373 156.664 432.68 150.142 396.847 165.487C361.979 180.419 334.076 220.685 297.342 211.1C259.553 201.239 245.417 156.91 228.624 121.591C211.16 84.8593 184.078 44.7345 200.597 7.62301C216.888 -28.976 264 -36.96 303.069 -45.6555Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.291 98.3171C406.168 101.522 424.522 123.325 443.936 142.205C463.807 161.528 489.51 179.224 490.969 206.917C492.47 235.374 473.83 261.634 451.139 278.84C430.983 294.124 404.576 291.852 379.291 291.602C354.396 291.355 325.72 295.761 308.854 277.429C292.226 259.355 303.26 231.416 301.384 206.917C299.207 178.474 280.54 147.873 297.163 124.702C314.597 100.399 349.612 94.7779 379.291 98.3171Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19925"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.738281,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7);
export default __webpack_public_path__ + "static/media/card7.7803c8399b73beed9b273c9af2f6910f.svg";
export { ForwardRef as ReactComponent };